/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Object_TypeInputs */

const cs_form_object_type = /** @type {(inputs: Form_Object_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ objektu`)
};

const en_form_object_type = /** @type {(inputs: Form_Object_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Object type`)
};

/**
* | output |
* | --- |
* | "Object type" |
*
* @param {Form_Object_TypeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_object_type = /** @type {((inputs?: Form_Object_TypeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Object_TypeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_object_type(inputs)
	return cs_form_object_type(inputs)
});